import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { LoaderService } from '../loader/loader.service';
import { LoginService } from '../login/login.service';

@Injectable({
  providedIn: 'root'
})
export class UnauthGuard implements CanActivate {
  constructor(
    private loginService: LoginService,
    private loaderService: LoaderService,
    private router: Router
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): boolean {
    const session = this.loginService.getStoredSession();
    if (!session || !this.loginService.hasActiveSession()) {
      return true;
    }

    const navigation = this.loginService.determinePostLoginNavigation(session);

    if (navigation && navigation.commands) {
      if (navigation.showLoader) {
        this.loaderService.show();
      }
      this.router.navigate(navigation.commands);
      return false;
    }

    return false;
  }
}
